import React from 'react';
import t from 'prop-types';

function Recorte(_ref) {
  var index = _ref.index,
      x = _ref.x,
      y = _ref.y,
      w = _ref.w,
      h = _ref.h,
      onEliminar = _ref.onEliminar;
  var left = w > 0 ? x : x + w;
  var top = h > 0 ? y : y + h;
  var width = w > 0 ? w : -w;
  var height = h > 0 ? h : -h;
  return React.createElement('div', {
    className: 'recorte',
    key: 'recorte-' + index,
    style: {
      position: "absolute",
      left: left + '%',
      top: top + '%',
      width: width + '%',
      height: height + '%',
      cursor: "pointer"
    },
    'data-index-recorte': index
  }, onEliminar && React.createElement('div', {
    onClick: function onClick() {
      return onEliminar(index);
    },
    style: {
      right: 0,
      top: 0,
      position: 'absolute'
    }
  }, 'x'));
}

Recorte.propTypes = process.env.NODE_ENV !== "production" ? {
  index: t.number,
  x: t.number,
  y: t.number,
  w: t.number,
  h: t.number,
  onEliminar: t.func
} : {};
export default Recorte;